import { render, staticRenderFns } from "./AdminSidebarGroup.vue?vue&type=template&id=8153d4de"
import script from "./AdminSidebarGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebarGroup.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports